import React, { useContext } from "react";
import "./styles.less"
import InputFilterBox from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/InputFilterBox/web";
import { useSearchResultsFilters } from "shared-components/ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { useAmenities } from "shared-components/Components/Filters/Amenities/Amenities.hook";
import { Amenities } from "shared-components/Components/Filters/Amenities/web";

export const AmenitiesFilter = () => {
	const { country_code } = useContext(ConfigStateContext);
	const { filters } = useFilters()
	const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters()
	const { ammenitieActiveIsNotMain, showComponent } = useAmenities({country_code});

    const isActive = () => {
        if (
            filters?.facilitiesGroup?.length > 0 ||
            filters?.garage ||
            filters?.tour3d ||
            filters?.privateOwner ||
            filters?.socialHousing ||
            filters?.seen ||
            filters?.seaview
        ) return true
        else return false
    }

    const handleCleanFilter = () => {
        const valuesToReset = {
            facilitiesGroup: [],
            garage: null,
            tour3d: null,
            privateOwner: null,
            socialHousing: null,
            seen: null,
            seaview: null
        }

        changeFilters(valuesToReset)
    }

    if (!showComponent) return null;

    return (
        <InputFilterBox
            active={isActive()}
            customWidth={400}
            label='Extras'
            onCancelFilter={handleCleanFilter}
            scrollable
        >
            <div className="optionList add-padding remove-hr">
                <Amenities openByDefault={ammenitieActiveIsNotMain} />
            </div>
        </InputFilterBox>
    )
}